import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Angular Material Modules
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox'; // For remember me
import { MatTooltipModule } from '@angular/material/tooltip';

// Components
import { LoginComponent } from './components/login/login.component';
import { LcSelectorModalComponent } from './components/lc-selector-modal/lc-selector-modal.component';
import { OtpVerificationModalComponent } from './components/otp-verification-modal/otp-verification-modal.component';
import { TotpSetupModalComponent } from './components/totp-setup-modal/totp-setup-modal.component';

// Routing
import { LoginRoutingModule } from './login-routing.module';

// Services
import { AuthService } from     './services/auth.service';

@NgModule({
  declarations: [
    LoginComponent,
    LcSelectorModalComponent,
    OtpVerificationModalComponent,
    TotpSetupModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule, // If you plan to use reactive forms
    HttpClientModule,
    LoginRoutingModule,
    // Angular Material Modules
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatListModule,
    MatIconModule,
    MatCheckboxModule,
    MatTooltipModule
  ],
  providers: [
    AuthService // Provide the authentication service
  ],
  exports: [LoginComponent],
  // Entry components are typically not needed for Angular Material dialogs
  // as they are dynamically created.
})
export class LoginModule { }
